/**
 * Created by vonsh on 2018/9/7
 */
import Vue from 'vue'

const extendBus = Vue.extend({
  mixins: [{
    methods: {
      $bind: function (evt, cbk) {
        if (this._events[evt]) {
          this._events[evt].pop()
          this._events[evt].push(cbk)
        } else {
          this.$on(evt, cbk)
        }
      }
    }
  }]
})

export default new extendBus();



// WEBPACK FOOTER //
// ./src/assets/js/Bus.js